import React from 'react';

type LogoProps = {
  size?: number;
  withWordmark?: boolean;
  className?: string;
};

/**
 * PabSync mark — nested rotated squares ("sync" of layers) rendered as
 * inline SVG so it stays crisp at any size and adds no image request.
 */
export const LogoMark: React.FC<{ size?: number; className?: string }> = ({
  size = 30,
  className,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="6.5"
      y="6.5"
      width="35"
      height="35"
      rx="8"
      stroke="var(--brand-primary)"
      strokeWidth="3.5"
    />
    <rect
      x="15"
      y="15"
      width="18"
      height="18"
      rx="4"
      transform="rotate(-14 24 24)"
      stroke="var(--brand-primary)"
      strokeWidth="3"
      opacity="0.55"
    />
    <rect
      x="17.5"
      y="17.5"
      width="13"
      height="13"
      rx="3"
      transform="rotate(-14 24 24)"
      stroke="var(--accent)"
      strokeWidth="3"
    />
  </svg>
);

const Logo: React.FC<LogoProps> = ({
  size = 30,
  withWordmark = true,
  className,
}) => (
  <span className={`brand${className ? ` ${className}` : ''}`}>
    <LogoMark size={size} />
    {withWordmark && <span className="brand__word">PabSync</span>}
  </span>
);

export default Logo;
